import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { find } from 'lodash';
import {
  Button,
} from 'reactstrap';
import {
  dateFormats, calculateDateDiff, OFFER_STATUS, BETA_POST_ENUM, MediaRender,
  getLocalUserData, staticConstants, ERROR_ICON, getDaysDiff, NUMERIC_VALUE,
} from '../../../utils';
import MediaPopup from '../../modals/MediaPopup';
import CompleteBetaPost from './CompleteBetaPost';

/* function to show the sharetype icons */
function shareTypeIcons(item) {
  if (item.facebook || item.instagram || item.twitter || item.youtube || item.spotify) {
    return (
      <div className="share-on">
        <span>Share on:</span>
        <ul>
          {item.instagram && <li className="instagram" />}
          {item.facebook && <li className="facebook" />}
          {item.twitter && <li className="twitter" />}
          {item.youtube && <li className="youtube" />}
          {item.spotify && <li className="spotify" />}
        </ul>
      </div>
    );
  }
  return null;
}
/* function to show the complete status */
function completePostStatue(status) {
  if (status === BETA_POST_ENUM.PUBLISHED) {
    return (
      <>
        <h4 className="beta-post-tag completed">
          <span className="icon icon-tick" />
          Completed
        </h4>
      </>
    );
  }
  return null;
}
/* function to show the sharetype icons */
function sharedSocialPostUrl(status, sharedType) {
  if (status === BETA_POST_ENUM.PUBLISHED) {
    return (
      <>
        <div className="see-this-post">
          <span>See This Post</span>
          <div className="modal-request-account-social-icons">
            {sharedType.instagramUrl
              && <a className="social-icon instagram" href={sharedType.instagramUrl} target="_blank" rel="noopener noreferrer" />}
            {sharedType.facebookUrl
              && <a className="social-icon facebook" href={sharedType.facebookUrl} target="_blank" rel="noopener noreferrer" />}
            {sharedType.twitterUrl
              && <a className="social-icon twitter" href={sharedType.twitterUrl} target="_blank" rel="noopener noreferrer" />}
            {sharedType.youtubeUrl
              && <a className="social-icon youtube" href={sharedType.youtubeUrl} target="_blank" rel="noopener noreferrer" />}
            {sharedType.spotifyUrl
              && <a className="social-icon spotify" href={sharedType.spotifyUrl} target="_blank" rel="noopener noreferrer" />}
          </div>
        </div>
      </>
    );
  }
  return null;
}

/* function to return the text of the post created */
function isHashTag(item) {
  if (item && (item.status === BETA_POST_ENUM.BETA_POST_REQUESTED_ADMIN || item.status === BETA_POST_ENUM.BETA_POST_APPROVED)) {
    return item.betaPostInfo;
  }
  return null;
}

/* function to check whether the request of the post is sent to the admin
    returns the specified text for the status */
function isRequestSent(item) {
  if (item === BETA_POST_ENUM.BETA_POST_REQUESTED_ADMIN) {
    return <h4 className="beta-post-tag approval">Draft post sent for approval</h4>;
  }
  return null;
}

/* function to check whether the request of the post is accepted by the admin
      returns the specified text for the status */
function isPostAccepted(item) {
  if (item === BETA_POST_ENUM.BETA_POST_APPROVED) {
    return (
      <h4 className="beta-post-tag accepted">
        <span className="icon icon-tick" />
        {' '}
        Draft Post Accepted. Publish Post
      </h4>
    );
  }
  return null;
}

/* function to show the expires, posted on and missed deadline text */
const expiresText = (endDate, postStatus, postEndDate, showRedTextClass, status, showExpiresDaysLeft) => {
  let text = '';
  if (postStatus === OFFER_STATUS.PUBLISHED) {
    text = (
      <p className={`expires ${showRedTextClass && 'icon-red'}`}>
        {calculateDateDiff(new Date(), endDate, postStatus, postEndDate)}
        {getDaysDiff(new Date(), postEndDate) > 0 && (
          <span className="deadline-text">
            Missed deadline
          </span>
        )}
      </p>
    );
  } else if (calculateDateDiff(new Date(), endDate, postStatus, postEndDate) === 'Expired') {
    text = (
      <p className={`expires ${showRedTextClass && 'icon-red'}`}>
        Missed deadline
      </p>
    );
  } else {
    text = (status === OFFER_STATUS.CONTRACT_ACCEPTED && showExpiresDaysLeft
      && (
      <p className="expires icon-red">
        {calculateDateDiff(new Date(), endDate, postStatus, postEndDate)}
      </p>
      )
    );
  }
  return text;
};

/* function called to populate the date difference by calling calculateDateDiff function */
export function isDateDiff(item, status) {
  const { endDate } = item;
  let postEndDate = '';
  let postStatus = '';
  let showRedTextClass = false;
  if ([OFFER_STATUS.ADMIN_ACCEPTED, OFFER_STATUS.CONTRACT_ACCEPTED, OFFER_STATUS.ARTIST_ACCEPTED,
    OFFER_STATUS.COMPLETED].indexOf(status) > -1) {
    const publishedDetail = find(item.timeLine, { status: OFFER_STATUS.PUBLISHED });
    if (publishedDetail) {
      postEndDate = publishedDetail.createdAt;
      postStatus = publishedDetail.status;
    } else {
      postStatus = status;
      const result = getDaysDiff(new Date(), endDate);
      showRedTextClass = result <= NUMERIC_VALUE.TWO;
    }
    const canShowExpiresDaysLeft = [BETA_POST_ENUM.ELIGIBLE, BETA_POST_ENUM.BETA_POST_CREATED, BETA_POST_ENUM.REJECTED].indexOf(item.status) > -1;
    return expiresText(endDate, postStatus, postEndDate, showRedTextClass, status, canShowExpiresDaysLeft);
  }
  return null;
}

/* function to render the complete section where the shared urls will be asked in text fields */
function renderCompleteSection(item, role, handlePublishBetaPost, offerMaxDate, isBetaPostAutoApproval, isContractAccepted) {
  if (((item.status === BETA_POST_ENUM.BETA_POST_APPROVED || isBetaPostAutoApproval) && isContractAccepted) && (role !== staticConstants.ROLE.SYSTEM_ADMIN)
    && getDaysDiff(new Date(), offerMaxDate) > 0) {
    return (
      <>
        <CompleteBetaPost betaPostData={item} handlePublishBetaPost={handlePublishBetaPost} />
      </>
    );
  }
  return null;
}
function CampaignTimeline(props) {
  const {
    data, status, toggleCreateBetaPostModal, handlePublishBetaPost, segmentId,
    offerMaxDate, isFromPublicPage, contractDate, isBetaPostAutoApproval, isContractAccepted,
  } = props;
  const campaignRef = useRef([]);
  const { role } = getLocalUserData();
  const [mediaPopup, setMediaPopup] = useState(false);
  const [mediaItem, setMediaItem] = useState();

  const toggleMediaModal = () => {
    setMediaPopup(!mediaPopup);
  };

  useEffect(() => {
    campaignRef.current = [];
    setTimeout(() => {
      segmentId && campaignRef.current[segmentId] && campaignRef.current[segmentId].scrollIntoView();
    }, 1000);
  }, [props]);

  const createMarkup = (content) => ({ __html: content });

  /* function called on click of media post to open image or video in modal
    timeline segment object passed as a variable */
  const openMediaPopup = (item) => {
    setMediaPopup(true);
    setMediaItem(item);
  };

  /* function to check if the status of the segment is eligible
    returns the media posted in create beta post */
  const createPost = (item) => {
    if (item.status === BETA_POST_ENUM.REJECTED || item.status === BETA_POST_ENUM.BETA_POST_REQUESTED_ADMIN
      || item.status === BETA_POST_ENUM.BETA_POST_APPROVED) {
      return (
        <div className="media-file-wrapper">
          <h5>{item.status === BETA_POST_ENUM.BETA_POST_APPROVED ? 'APPROVED POST:' : 'POST YOU SENT:'}</h5>
          {' '}
          {item.status === BETA_POST_ENUM.REJECTED && (
            <div className="reject-reason">
              <h4>{`${item.rejectReason.preDefined} ${item.rejectReason.custom}`}</h4>
            </div>
          )}
          {MediaRender(item.media).map((obj) => (
            <div
              key={Math.random()}
              className="media-file"
              onClick={() => openMediaPopup(obj && obj.file)}
            >
              {obj && obj.media}
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  /* function to return the create beta post button */
  const sendForApproval = (item) => {
    if ((item.status === BETA_POST_ENUM.ELIGIBLE || item.status === BETA_POST_ENUM.BETA_POST_CREATED)
    && !isBetaPostAutoApproval && (role !== staticConstants.ROLE.SYSTEM_ADMIN) && getDaysDiff(new Date(), offerMaxDate) > 0) {
      return (
        <Button
          color="primary"
          element="inlineBlock"
          className="beta-post-btn"
          onClick={() => { toggleCreateBetaPostModal(item); }}
        >
          Create draft post
        </Button>
      );
    }
    return null;
  };

  /* function to return the modify post button in case of rejected request */
  const isModifyPost = (item) => {
    if (item.status === BETA_POST_ENUM.REJECTED && (role !== staticConstants.ROLE.SYSTEM_ADMIN)) {
      return (
        <Button
          color="primary"
          element="inlineBlock"
          className="beta-post-btn"
          onClick={() => toggleCreateBetaPostModal(item, true)}
        >
          Modify draft post
        </Button>
      );
    }
    return null;
  };

  const renderHashTags = (item) => (
    <p>
      {' '}
      {item.hashTag}
    </p>
  );

  return (

    <div className="modal-offer-detail-timeline pl-3 pb-5">
      {isFromPublicPage && (
        <div className="modal-offer-detail-timeline-row">

          <div className="modal-offer-detail-timeline-head">
            <h3>
              <span>
                contract signed on
                {` ${moment(contractDate.createdAt).format(dateFormats.DATE_WITH_YEAR)}`}
              </span>
            </h3>
          </div>
        </div>
      )}
      {data && data.map((item) => (
        <div
          ref={(el) => { campaignRef.current[item._id] = el; }}
          className={`modal-offer-detail-timeline-row
          ${item.status === BETA_POST_ENUM.REJECTED ? 'box-error' : ''} ${item.status === BETA_POST_ENUM.PUBLISHED ? 'box-completed' : ''}`}
          key={item._id}
        >
          {/* <div className="timeline-date-card">
            <p>
              {moment(item.startDate).format('D')}
              <span>{moment(item.startDate).format('MMM')}</span>
            </p>
          </div> */}
          <div className="timeline-box-detail-section">
            <div className={`modal-offer-detail-timeline-head ${item.status === BETA_POST_ENUM.REJECTED && 'box-red'}`}>
              <h3>
                {moment(item.startDate).format(dateFormats.DATE_WITH_YEAR) === moment(item.endDate).format(dateFormats.DATE_WITH_YEAR)
                  ? (
                    <span className="mr-3">
                      { `${moment(item.startDate).format(dateFormats.DAY_DATE_WITHOUT_YEAR)}`}
                    </span>
                  )
                  : (
                    <span className="mr-3">
                      { `${moment(item.startDate).format(dateFormats.DAY_DATE_WITHOUT_YEAR)}
                - ${moment(item.endDate).format(dateFormats.DAY_DATE_WITHOUT_YEAR)}`}
                    </span>
                  )}
                {isRequestSent(item.status)}
                {isPostAccepted(item.status)}
                {shareTypeIcons(item.shareType)}
                {completePostStatue(item.status)}
                {role !== staticConstants.ROLE.SYSTEM_ADMIN && item && item.status === BETA_POST_ENUM.REJECTED
                  && (
                    <div className="error-text">
                      <img
                        src={ERROR_ICON}
                        alt="offer"
                      />
                      Rejected
                    </div>
                  )}
              </h3>
            </div>
            <div
              className={`modal-offer-detail-timeline-data
              ${[BETA_POST_ENUM.NOT_ELIGIBLE, BETA_POST_ENUM.ELIGIBLE, BETA_POST_ENUM.BETA_POST_CREATED, BETA_POST_ENUM.REJECTED].indexOf(item.status) === -1 && 'box-none'}`}
            >
              <h2 dangerouslySetInnerHTML={createMarkup(item.campaignTitle)} />
              <p dangerouslySetInnerHTML={createMarkup(item.description)} />
              {isDateDiff(item, status) === 'Expired' ? 'Missed Deadline' : isDateDiff(item, status)}
              {sharedSocialPostUrl(item.status, item.sharedPost)}
              {createPost(item)}
              {renderHashTags(item)}
              {isHashTag(item)}
              {sendForApproval(item)}
              {isModifyPost(item)}
              {item.status !== BETA_POST_ENUM.PUBLISHED && renderCompleteSection(item, role, handlePublishBetaPost, offerMaxDate, isBetaPostAutoApproval, isContractAccepted) }
            </div>
          </div>
        </div>
      ))}
      {mediaPopup && (
        <MediaPopup
          isOpen={mediaPopup}
          onClose={() => { toggleMediaModal(); }}
          timelineData={mediaItem}
          renderImageWithDownloadLink
          renderVideoWithDownloadLink
        />
      )}
    </div>
  );
}

CampaignTimeline.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    campaignTitle: PropTypes.string,
    description: PropTypes.string,
    segmentId: PropTypes.string,
    isArtistParticipation: PropTypes.bool,
    isBetaPostApproval: PropTypes.bool,
    shareType: PropTypes.shape({
      facebook: PropTypes.bool,
      instagram: PropTypes.bool,
      twitter: PropTypes.bool,
      youtube: PropTypes.bool,
      spotify: PropTypes.bool,
    }),
    sharedPost: PropTypes.shape({
      facebookUrl: PropTypes.string,
      instagramUrl: PropTypes.string,
      twitterUrl: PropTypes.string,
      youtubeUrl: PropTypes.string,
      spotifyUrl: PropTypes.string,
    }),
  })),
  status: PropTypes.string,
  isBetaPostAutoApproval: PropTypes.bool,
  isContractAccepted: PropTypes.bool,
  toggleCreateBetaPostModal: PropTypes.func,
  handlePublishBetaPost: PropTypes.func,
  segmentId: PropTypes.string,
  offerMaxDate: PropTypes.string,
  isFromPublicPage: PropTypes.bool,
  contractDate: PropTypes.object,
};
CampaignTimeline.defaultProps = {
  status: null,
  data: [],
  toggleCreateBetaPostModal: null,
  handlePublishBetaPost: null,
  segmentId: null,
  offerMaxDate: null,
  isFromPublicPage: false,
  contractDate: {},
  isBetaPostAutoApproval: false,
  isContractAccepted: false,
};

export default CampaignTimeline;
